import PeerInsert from './peerInsert'
import PeerDetail from './peerDetail'
import PeerResult from './peerResult'
import PeerUpdate from './peerUpdate'
import TeacherInsert from './teacherInsert'
import TeacherResult from './teacherResult'
import TeacherAllResult from './teacherAllResult'
import LeaderInsert from './leaderInsert'
import LeaderResult from './leaderResult'
import LeaderAllResult from './leaderAllResult'
import leaderTargetAnalysisByOptions from './leaderTargetAnalysisByOptions'
import leaderTargetAnalysisByOrg from './leaderTargetAnalysisByOrg'
import teacherTargetAnalysisByOptions from './teacherTargetAnalysisByOptions'
import teacherTargetAnalysisByOrg from './teacherTargetAnalysisByOrg'

export default {
    PeerInsert ,
    PeerResult ,
    PeerUpdate,
    TeacherInsert ,
    TeacherResult ,
    TeacherAllResult ,
    LeaderInsert ,
    LeaderResult ,
    LeaderAllResult,
    leaderTargetAnalysisByOptions,
    leaderTargetAnalysisByOrg,
    teacherTargetAnalysisByOptions,
    teacherTargetAnalysisByOrg,
    PeerDetail
}